import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  ClientCalllogDto,
  ClientDetailDto,
  ClientLocationDto,
  ClientPurchasedPackageDto,
} from "src/store/clients/type";
import DataGrid from "src/components/Page/Datagrid";
import {
  deleteClientCallogs,
  getClientCallogByClientId,
  getClientCallogDetail,
  getClientLocationDetail,
  getClientLocations,
} from "src/store/clients/saga";
import LocationEditForm from "./edit";
import LocationCreateForm from "./create";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { GetLocaleDate } from "src/helpers/getLocaleDate";

const ClientCalllogsTab = ({
  client,
  active,
}: {
  active: string;
  client: ClientDetailDto;
}) => {
  const { t } = useTranslation();
  const [dataList, setDataList] = useState<ClientCalllogDto[]>([]);
  const dispatch = useDispatch();
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<ClientCalllogDto>();
  const columns = [
    {
      text: t("Clients.Calllogs.Status"),
      dataField: "ClientCallLogStatus",
    },
    {
      text: t("Clients.Calllogs.Note"),
      dataField: "Note",
    },
    {
      text: t("Clients.Calllogs.NextCallDate"),
      dataField: "NextCallDate",
      formatter: (c: any) => GetLocaleDate(c),
    },
    {
      text: t("Clients.Calllogs.NextCallNote"),
      dataField: "NextCallNote",
    },
  ];

  return (
    <React.Fragment>
      {active === "4" && (
        <DataGrid
          hideBreadcrumbs
          isDetails
          listData={dataList}
          setDataList={setDataList}
          action={getClientCallogByClientId}
          paramsid={client.Id}
          addTitle={t("Clients.Calllogs.AddButton").toString()}
          onCreateClick={() => setShowCreate(true)}
          columns={columns}
          editButton={{
            onClick: (id, data) => {
              dispatch(
                getClientCallogDetail({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          }}
          deleteButton={{
            text: (id, data: ClientCalllogDto) =>
              t("Clients.Calllogs.DeleteQA"),
            action: deleteClientCallogs,
            onClick: (id, data) => setShowEdit(data),
          }}
        />
      )}
      <LocationCreateForm
        open={showCreate}
        client={client}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getClientCallogByClientId,
            setDataList: setDataList,
            id: client.Id,
          })
        }
      />
      {selected && (
        <LocationEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getClientCallogByClientId,
              setDataList: setDataList,
              id: client.Id,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ClientCalllogsTab;
